import http from "../../../assets/extra/_httpServices";
import { updateLoadingScreen } from "../../../redux/Actions";
import { urls } from "../../../components/common/constants";
import * as types from "./OthersActionType";
import axios from 'axios';

const updateUserList = (data) => {
  return {
    type: types.USER_LIST,
    payload: data,
  }
}
const updateBusStationList = (data) => {
  return {
    type: types.BUS_STATION_LIST,
    payload: data,
  }
}

const updateTimeTableData = (data) => {
  return {
    type: types.TIME_TABLE_DATA,
    payload: data,
  }
}

export const getFranchiseUserList = (params) => {
  return (dispatch) => {
    http
      .HttpGet(urls?.getFranchiseUserList, params)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateBusStationList(response.data.Data.Table));
          dispatch(updateUserList(response.data.Data.Table1));
        } else {
          dispatch(updateUserList([]));
          dispatch(updateBusStationList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateUserList([]));
        dispatch(updateBusStationList([]))
      });
  };
};

export const getPenaltySearchList = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getPenaltySearchList, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const addPenalty = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getPenaltyInsert, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getTicketModifyData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getTicketModification, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getTicketModify = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpCall(urls.getTicketModify, "post", {}, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getDelaySmsData = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getDelaySms, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getDelaySmsPNRTckt = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getDelaySmsPNRTckt, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

//Boarding Actions
export const getBoardingListData = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getBoardingData, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getAreaListData = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getAreaListData, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

//manage News
export const getBoardingDataSave = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpCall(urls.getBoardingDataSave, "post", {}, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const addManageNews = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getManageNewsInsert, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getManageNewsSearchList = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getManageNewsSearchList, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getTimeTableData = (params) => {
  return (dispatch) => {
    dispatch(updateLoadingScreen(true))
    http.HttpGet(urls?.getTimeTable, params)
      .then((response) => {
        dispatch(updateLoadingScreen(false))
        if (response.status === 200 && response.data.status) {
          dispatch(updateTimeTableData(response.data.Data.Table));
        } else {
          dispatch(updateTimeTableData([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateLoadingScreen(false))
        dispatch(updateTimeTableData([]))
      })
  }
}

export const insertUpdateTimeTableData = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpCall(urls.insertUpdateTimeTable, "post", {}, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getManageOnlineUsersList = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true)); // Dispatch action to show loading screen
    axios.get(
      ` https://betaksrtc.iamgds.com/api/resource/filteredUserDetails`, { params: data }) // Making a GET request using Axios
      .then((res) => {
        dispatch(updateLoadingScreen(false)); // Dispatch action to hide loading screen
        resolve(res); // Resolve with response data
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false)); // Dispatch action to hide loading screen
        reject(error); // Reject with error
      });
  });
};

export const getOnlineUsersInfo = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true)); // Dispatch action to show loading screen
    axios.get(
      `https://betaksrtc.iamgds.com/api/resource/userDetailsV1`, { params: data }) // Making a GET request using Axios
      .then((res) => {
        dispatch(updateLoadingScreen(false)); // Dispatch action to hide loading screen
        resolve(res); // Resolve with response data
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false)); // Dispatch action to hide loading screen
        reject(error); // Reject with error
      });
  });
};

export const resetUserPassword = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    axios.post(
      // 'https://betaksrtc.iamgds.com/api/resource/resetPasswordV1',
      'https://ksrtc.in/api/resource/resetPasswordV1',
      data
    )
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getBoardingDataSaveV2 = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpCall(urls.getBoardingDataSaveV2, "post", {}, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const sendDelaySms = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpCall(urls.sendDelaySms, "post", {}, body)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getAuditReportData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getAuditReport, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getOnlineUserListReport1 = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true)); // Dispatch action to show loading screen
    axios.get(
      // ` https://betaksrtc.iamgds.com/api/resource/filteredUserDetails?`, { params: data }) // Making a GET request using Axios
      ` https://ksrtc.in/api/resource/filteredUserDetails?`, { params: data }) // Making a GET request using Axios
      .then((res) => {
        dispatch(updateLoadingScreen(false)); // Dispatch action to hide loading screen
        resolve(res); // Resolve with response data
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false)); // Dispatch action to hide loading screen
        reject(error); // Reject with error
      });
  });
};

export const getListofPaymentDoneModPending = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getListofPaymentDoneModPending, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const updatePOSRefund = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpCall(urls.updatePOSRefund, "post", body, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
const handleRequest = async (httpMethod, url, data, dispatch, loader) => {
  try {
    if (loader) {
      dispatch(updateLoadingScreen(true));
    }
    const response = await httpMethod(url, data);
    if (loader) {
      dispatch(updateLoadingScreen(false));
    }
    return response;
  } catch (error) {
    if (loader) {
      dispatch(updateLoadingScreen(false));
    }
    throw error;
  }
};

export const GetPromise = (url, data, loader = false) => (dispatch) => {
  return handleRequest(http.HttpGet, url, data, dispatch, loader);
};

export const PostPromise = (url, data, loader = false) => (dispatch) => {
  return handleRequest((url, data) => http.HttpCall(url, "post", {}, data), url, data, dispatch, loader);
};



export const getPOSPSCheck = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getPOSPSCheck, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};